import React, { Component } from "react";
import PersonCard from "../components/PersonCard";

class Staff extends Component {
	constructor(props) {
		super(props);
		this.state = {
			people: [],
		};
	}
	componentDidMount() {
		const people = [
			{
				name: "खिम बहादुर खड्का",
				nameEnglish: "Chandrakanta Paudel",
				designation: "प्रमुख प्रशासकीय अधिकृत",
				designationEnglish: "Chief Administrative Officer",
				email: "khadkakhim490@gmail.com",
				phone: "९८४४९७८२११",
				phoneEnglish: "9844978211",
				address: "दंगीशरण गाउँपालिका दाङ",
				addressEnglish:
					"Dangisharan rural municipality dang, lumbini pradesh, Nepal",
				image: "media/hamropalika/people/st-3.jpg",
				containerClass: "col-sm-6 col-md-12 col-xl-6",
			},
			{
				name: "विनोद अधिकारी",
				nameEnglish: "Binod Adhikari",
				designation: "सूचना अधिकारी",
				designationEnglish: "Information Officer",
				email: "N/A",
				phone: "९८४७८४३५९१",
				phoneEnglish: "9847843591",
				address: "दंगीशरण गाउँपालिका दाङ, लुम्बिनी प्रदेश, नेपाल",
				addressEnglish: "Dangisharan rural municipality dang",
				image: "media/hamropalika/people/st4.jpg",
				containerClass: "col-sm-6 col-md-12 col-xl-6",
			},
		];
		this.setState({ people });
	}
	render() {
		return (
			<div className="row h-100">
				{this.state.people.map((person, index) => {
					return <PersonCard data={person} key={index} />;
				})}
			</div>
		);
	}
}

export default Staff;
